import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';

import { CUSTOM_REVIEW_SOURCE, WEBSITE_REVIEW_SOURCE } from '../../constants';

export function isCustomReview(source) {
  if (!source) {
    return false;
  }

  return source.toLowerCase() === CUSTOM_REVIEW_SOURCE;
}

export function getSourceIconName(source = '') {
  if (source.toLowerCase() === WEBSITE_REVIEW_SOURCE) return 'globe';
  return source.toLowerCase();
}

export function getSentiment(score) {
  if (score <= 2) return { text: 'Negative', color: 'red' };
  if (score === 3) return { text: 'Neutral', color: 'yellow' };
  return { text: 'Positive', color: 'green' };
}

export function isReviewResponseCreated(reviewResponse) {
  if (!reviewResponse) {
    return false;
  }

  const { review: reviewId } = reviewResponse;
  return !!reviewId;
}

export function getReviewResponse(review) {
  return _get(review, 'reviewResponse') || {};
}

export function isReviewFlagged(review) {
  return _get(review, 'flagged');
}

export function getReviewFlaggedReason(review) {
  const reason = _get(review, 'flaggedReason', '');
  return `Issue: ${reason} \nPlease consider requesting a removal before responding to this review.`;
}

export function isReviewResponseEmpty(reviewResponse) {
  if (!reviewResponse) {
    return true;
  }

  const { content } = reviewResponse;
  return _isEmpty(content);
}

export function getFilteredReviews(reviews, { sources, status, searchQuery, locationId }) {
  let filteredReviews = reviews || [];

  filteredReviews = filteredReviews.filter((review) =>
    isReviewResponseCreated(getReviewResponse(review)),
  );

  filteredReviews = filteredReviews.filter(({ submissionEnabled }) => submissionEnabled);

  if (!_isEmpty(sources)) {
    filteredReviews = filteredReviews.filter(({ source }) => sources.includes(source));
  }

  if (status) {
    filteredReviews = filteredReviews.filter(({ status: s }) => s === status);
  }

  if (locationId) {
    filteredReviews = filteredReviews.filter(({ location }) => location === locationId);
  }

  if (searchQuery.trim()) {
    const trimmedQuery = searchQuery.trim();
    const searchLower = trimmedQuery.toLowerCase();

    filteredReviews = filteredReviews.filter(({ text, author, source }) => {
      if (text && text.toLowerCase().includes(searchLower)) {
        return true;
      }
      if (author && author.toLowerCase().includes(searchLower)) {
        return true;
      }
      return source && source.toLowerCase().includes(searchLower);
    });
  }

  filteredReviews = filteredReviews.sort((a, b) => {
    const aDate = new Date(a.sourceUpdatedAt || 0);
    const bDate = new Date(b.sourceUpdatedAt || 0);
    return bDate - aDate;
  });

  return filteredReviews;
}
